<template>
  <div class="index">
    <div class="index-header">
      <el-form :model="form" :inline="true" label-width="110px">
        <div class="input-box" v-show="!out">
          <div>
            <label style="margin:5px 10px 0 20px;">地区：</label>
          </div>
          <div style="margin-bottom:15px">  
            <Area :value="area_data" :diss="dis" :arr="arrPlace1" @getPlace="getPlace1"/>
          </div>
          <div style="margin-right:10px">
            <el-form-item label="开始时间：" prop="startCreateTime">
              <el-date-picker type="date" v-model="form.startCreateTime" value-format="timestamp" placeholder="选择日期" />
            </el-form-item>
            <el-form-item label="结束时间：" prop="endCreateTime">
              <el-date-picker type="date" v-model="form.endCreateTime" value-format="timestamp" placeholder="选择日期" />
            </el-form-item>
          </div>
          <div>
            <el-form-item>
              <el-button type="primary"
                @click="$data.paging_data.pageSize=$data.paging_data.total=1,
                Filter_file({api:api,data:form,callback:_d=>tableData=_d})"
                icon="el-icon-search">查询</el-button>
            </el-form-item>
          </div>
        </div>
        <div class="input-box" v-show="out">
          <div>
            <label style="margin:5px 10px 0 30px;">地区：</label>
          </div>
          <div style="margin-bottom:10px">
            <Area :value="area_data" :diss="dis" :arr="arrPlace2" @getPlace="getPlace2"/>
          </div>
          <div>
            <el-form-item label="统计开始时间：">
              <el-date-picker
                style="width:193px;"
                v-model="form1.startTime"
                value-format="timestamp"
                type="date"
                placeholder="选择日期">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="统计结束时间：">
              <el-date-picker
                style="width:193px;"
                v-model="form1.endTime"
                value-format="timestamp"
                type="date"
                placeholder="选择日期">
              </el-date-picker>
            </el-form-item>
          </div>
          <div>
            <el-form-item>
              <el-button type="primary"
                     @click=" $data.paging_data.pageSize = $data.paging_data.total = 1 ,
                    Filter_file({api:`${api}/report`,data:form1,callback:_d => tableData1 = _d })"
                     icon="el-icon-search">查询</el-button>
            </el-form-item>
          </div>
        </div>
      </el-form>
    </div>
    <div class="edit" v-show="!out">
      <el-button :disabled="selectRow.length==1?false:true" v-if="showBtn[1].isShow" icon="el-icon-edit" @click="openBox('edit')">编辑</el-button>
      <el-button icon="el-icon-edit" v-if="showBtn[3].isShow" @click="openBox('create')">创建</el-button>
      <el-button icon="el-icon-delete" v-if="showBtn[2].isShow" type="danger" @click="deleteDate('jtbttjb')">删除</el-button>
      <el-button style="padding: 0" v-if="showBtn[4].isShow"><file_Upload :_url="$public.upload_url._o"></file_Upload></el-button>
      <el-button type="primary" @click="downShow = true" icon="el-icon-document-remove">
        <!-- <a style="color:#fff" href="../model/交通补贴统计表--导入.xls" download="交通补贴统计表.xls">下载模板</a> -->
        下载模板
      </el-button>
    </div>
    <el-button  v-if="showBtn[5].isShow" type="primary" @click="out = !out" icon="el-icon-document-remove">{{out===false?'导出报表':'数据采集'}}</el-button>
    <div class="edit" v-show="out">
      <el-button type="primary" v-loading.fullscreen.lock="lodaingTime" @click="Filter_export(`${api}/export`,form)" icon="el-icon-document-remove">导出数据</el-button>
    </div>
    <div class="table" v-show="!out">
      <el-table
        :data="tableData"
        max-height="550"
        border
        @selection-change="handleSelectionChange"
        style="width: 99.9%">
        <el-table-column
          type="selection"
          width="40">
        </el-table-column>
        <el-table-column
          show-overflow-tooltip
          v-for="(item,index) in baseInfo"
          :key="index"
          :prop="item.key"
          :label="item.value"
          align="center">
        </el-table-column>
        <el-table-column label="自发输出" align="center">
          <el-table-column label="补贴金额（元）" align="center">
            <el-table-column
              show-overflow-tooltip
              v-for="(item,index) in baseInfo2"
              :key="index"
              :prop="item.key"
              :label="item.value"
              align="center">
            </el-table-column>
          </el-table-column>
          <el-table-column label="补贴人数" align="center">
            <el-table-column
              show-overflow-tooltip
              v-for="(item,index) in baseInfo3"
              :key="index"
              :prop="item.key"
              :label="item.value"
              align="center">
            </el-table-column>
          </el-table-column>
        </el-table-column>
        <el-table-column label="有组织输出" align="center">
          <el-table-column label="补贴金额（元）" align="center">
            <el-table-column
              show-overflow-tooltip
              v-for="(item,index) in baseInfo4"
              :key="index"
              :prop="item.key"
              :label="item.value"
              align="center">
            </el-table-column>
          </el-table-column>
          <el-table-column label="补贴人数" align="center">
            <el-table-column
              show-overflow-tooltip
              v-for="(item,index) in baseInfo5"
              :key="index"
              :prop="item.key"
              :label="item.value"
              align="center">
            </el-table-column>
          </el-table-column>
        </el-table-column>
      </el-table>
      <paging
          :pagesData="$data.paging_data"
          @set_page_number = 'get_page_number'
      ></paging>
    </div>
    <div class="table" v-show="out">
      <el-table
        :data="tableData1"
        max-height="550"
        border
        @selection-change="handleSelectionChange"
        style="width: 99.9%">
        <el-table-column
          show-overflow-tooltip
          v-for="(item,index) in baseInfo1"
          :key="index"
          :prop="item.key"
          :label="item.value"
          align="center">
        </el-table-column>
        <el-table-column label="自发输出" align="center">
          <el-table-column label="补贴总金额（元）" prop="personTotalFee" align="center">
          </el-table-column>
          <el-table-column label="补贴金额（元）" align="center">
            <el-table-column
              show-overflow-tooltip
              v-for="(item,index) in baseInfo2"
              :key="index"
              :prop="item.key"
              :label="item.value"
              align="center">
            </el-table-column>
          </el-table-column>
          <el-table-column label="补贴人数" align="center">
            <el-table-column
              show-overflow-tooltip
              v-for="(item,index) in baseInfo3"
              :key="index"
              :prop="item.key"
              :label="item.value"
              align="center">
            </el-table-column>
          </el-table-column>
        </el-table-column>
        <el-table-column label="有组织输出" align="center">
          <el-table-column label="补贴总金额（元）" prop="organizationTotalFee" align="center">
          </el-table-column>
          <el-table-column label="补贴金额（元）" align="center">
            <el-table-column
              show-overflow-tooltip
              v-for="(item,index) in baseInfo2"
              :key="index"
              :prop="item.key"
              :label="item.value"
              align="center">
            </el-table-column>
          </el-table-column>
          <el-table-column label="补贴人数" align="center">
            <el-table-column
              show-overflow-tooltip
              v-for="(item,index) in baseInfo3"
              :key="index"
              :prop="item.key"
              :label="item.value"
              align="center">
            </el-table-column>
          </el-table-column>
        </el-table-column>
      </el-table>
      <paging
          :pagesData="$data.paging_data"
          @set_page_number = 'get_page_number'
      ></paging>
    </div>
    <!-- 模态框 -->
    <el-dialog
      title="交通补贴统计表"
      :visible.sync="centerDialogVisible"
      :modal="false"
      @close="close"
      width="1400px"
      :close-on-click-modal="false"
      center>
      <div>
        <div class="edit-box">
          <div class="edit-item">
            <div class="edit-left">基本信息</div>
            <div class="edit-right">
              <div class="info-box">
                <div class="info-input">
                  <el-form label-width="210px" ref="editForm" :rules="rules" size="mini" :model="editForm">
                    <el-row>
                      <el-col :span="12">
                        <el-form-item label="地区：">
                          <Area   :value="area_data"
                              :diss="dis"
                              :name="arrPlace"
                              @getPlace="getPlace"/>
                        </el-form-item>
                        <el-form-item label="录入时间：">
                          <el-date-picker
                            style="width:193px;"
                            value-format="yyyy-MM-dd"
                            v-model="editForm.time"
                            type="date"
                            placeholder="选择日期">
                          </el-date-picker>
                        </el-form-item>
                        <el-form-item label="自发输出补贴：">
                        </el-form-item>
                        <el-form-item label="补贴金额(元)：">
                          <br />
                          <el-form-item label="市内：" label-width="90px" style="margin-left:-90px" prop="cityAllowanceFee">
                            <el-input placeholder="市内" style="width:193px;" v-model="editForm.cityAllowanceFee"></el-input>
                          </el-form-item>
                          <el-form-item label="市外省内：" label-width="90px" style="margin-left:-90px" prop="cityOutAllowanceFee">
                            <el-input placeholder="市外省内" style="width:193px;" v-model="editForm.cityOutAllowanceFee"></el-input>
                          </el-form-item>
                          <el-form-item label="省外：" label-width="90px" style="margin-left:-90px" prop="provinceOutAllowanceFee">
                            <el-input placeholder="省外" style="width:193px;" v-model="editForm.provinceOutAllowanceFee"></el-input>
                          </el-form-item>
                          <!-- <el-input placeholder="市内" style="width:193px;" v-model="editForm.cityAllowanceFee"></el-input><br />
                          <el-input placeholder="市外省内" style="width:193px;margin-top:8px;" v-model="editForm.cityOutAllowanceFee"></el-input><br />
                          <el-input placeholder="省外" style="width:193px;margin-top:8px;" v-model="editForm.provinceOutAllowanceFee"></el-input> -->
                        </el-form-item>
                        <el-form-item label="补贴人数：">
                          <br />
                          <el-form-item label="市内：" label-width="90px" style="margin-left:-90px" prop="cityAllowanceCount">
                            <el-input placeholder="市内" style="width:193px;" v-model="editForm.cityAllowanceCount"></el-input>
                          </el-form-item>
                          <el-form-item label="市外省内：" label-width="90px" style="margin-left:-90px" prop="cityOutAllowanceCount">
                            <el-input placeholder="市外省内" style="width:193px;" v-model="editForm.cityOutAllowanceCount"></el-input>
                          </el-form-item>
                          <el-form-item label="省外：" label-width="90px" style="margin-left:-90px" prop="provinceOutAllowanceCount">
                            <el-input placeholder="省外" style="width:193px;" v-model="editForm.provinceOutAllowanceCount"></el-input>
                          </el-form-item>
                          <!-- <el-input placeholder="市内" style="width:193px;" v-model="editForm.cityAllowanceCount"></el-input><br />
                          <el-input placeholder="市外省内" style="width:193px;margin-top:8px;" v-model="editForm.cityOutAllowanceCount"></el-input><br />
                          <el-input placeholder="省外" style="width:193px;margin-top:8px;" v-model="editForm.provinceOutAllowanceCount"></el-input> -->
                        </el-form-item>
                      </el-col>
                      <el-col :span="12">
                        <el-form-item label="有组织输出补贴：">
                        </el-form-item>
                        <el-form-item label="补贴金额(元)：">
                          <br />
                          <el-form-item label="市内：" label-width="90px" style="margin-left:-90px" prop="organizationCityAllowanceFee">
                            <el-input placeholder="市内" style="width:193px;" v-model="editForm.organizationCityAllowanceFee"></el-input>
                          </el-form-item>
                          <el-form-item label="市外省内：" label-width="90px" style="margin-left:-90px" prop="organizationCityOutAllowanceFee">
                            <el-input placeholder="市外省内" style="width:193px;" v-model="editForm.organizationCityOutAllowanceFee"></el-input>
                          </el-form-item>
                          <el-form-item label="省外：" label-width="90px" style="margin-left:-90px" prop="organizationProvinceOutAllowanceFee">
                            <el-input placeholder="省外" style="width:193px;" v-model="editForm.organizationProvinceOutAllowanceFee"></el-input>
                          </el-form-item>
                          <!-- <el-input placeholder="市内" style="width:193px;" v-model="editForm.organizationCityAllowanceFee"></el-input><br />
                          <el-input placeholder="市外省内" style="width:193px;margin-top:8px;" v-model="editForm.organizationCityOutAllowanceFee"></el-input><br />
                          <el-input placeholder="省外" style="width:193px;margin-top:8px;" v-model="editForm.organizationProvinceOutAllowanceFee"></el-input> -->
                        </el-form-item>
                        <el-form-item label="补贴人数：">
                          <br />
                          <el-form-item label="市内：" label-width="90px" style="margin-left:-90px" prop="organizationCityAllowanceCount">
                            <el-input placeholder="市内" style="width:193px;" v-model="editForm.organizationCityAllowanceCount"></el-input>
                          </el-form-item>
                          <el-form-item label="市外省内：" label-width="90px" style="margin-left:-90px" prop="organizationCityOutAllowanceCount">
                            <el-input placeholder="市外省内" style="width:193px;" v-model="editForm.organizationCityOutAllowanceCount"></el-input>
                          </el-form-item>
                          <el-form-item label="省外：" label-width="90px" style="margin-left:-90px" prop="organizationProvinceOutAllowanceCount">
                            <el-input placeholder="省外" style="width:193px;" v-model="editForm.organizationProvinceOutAllowanceCount"></el-input>
                          </el-form-item>
                          <!-- <el-input placeholder="市内" style="width:193px;" v-model="editForm.organizationCityAllowanceCount"></el-input><br />
                          <el-input placeholder="市外省内" style="width:193px;margin-top:8px;" v-model="editForm.organizationCityOutAllowanceCount"></el-input><br />
                          <el-input placeholder="省外" style="width:193px;margin-top:8px;" v-model="editForm.organizationProvinceOutAllowanceCount"></el-input> -->
                        </el-form-item>
                      </el-col>
                    </el-row>
                  </el-form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="centerDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submit()">确 定</el-button>
      </span>
    </el-dialog>
    <dowmloadplace :value="type" :downShow="downShow" @cutOff="cutOff"/>
  </div>
</template>

<script>
import mixins from '@/Mixins'
export default {
  mixins: [mixins],
  data() {
    let IntegerNumber = (rule, value, callback) => {
      if (!value){
        callback()
      } else {
        if ((Number.isInteger(Number(value)) && Number(value) > 0)){
          callback()
        } else {
          callback(new Error("请输入有效数字(正整数)"));  
        }
      }
    };
    return{
      api:'/user/trafficAllowance',
      type:'2',
      form:{},
      centerDialogVisible:false,
      tableData:[],
      tableData1:[],
      selectRow:[],
      baseInfo:[
        {key: 'time', value: '录入时间'},
        {key: 'province', value: '省'},
        {key: 'city', value: '市'},
        {key: 'county', value: '县'},
        {key: 'town', value: '镇'},
        {key: 'village', value: '村'},
      ],
      baseInfo1:[
        {key: 'areaName', value: '行政区划'},
        {key: 'totalFee', value: '总金额（元）'},
        {key: 'totalPerson', value: '总人数'},
      ],
      baseInfo2:[
        {key: 'cityAllowanceFee', value: '市内'},
        {key: 'cityOutAllowanceFee', value: '市外省内'},
        {key: 'provinceOutAllowanceFee', value: '省外'},
      ],
      baseInfo3:[
        {key: 'cityAllowanceCount', value: '市内'},
        {key: 'cityOutAllowanceCount', value: '市外省内'},
        {key: 'provinceOutAllowanceCount', value: '省外'}
      ],
      baseInfo4:[
        {key: 'organizationCityAllowanceFee', value: '市内'},
        {key: 'organizationCityOutAllowanceFee', value: '市外省内'},
        {key: 'organizationProvinceOutAllowanceFee', value: '省外'},
      ],
      baseInfo5:[
        {key: 'organizationCityAllowanceCount', value: '市内'},
        {key: 'organizationCityOutAllowanceCount', value: '市外省内'},
        {key: 'organizationProvinceOutAllowanceCount', value: '省外'}
      ],
      rules:{
        name: [
          { required: true, message: '请输入车间名', trigger: 'blur' }
        ],
        phone: [
          { required: true, message: '请输入电话', trigger: 'blur' }
        ],
        cityAllowanceFee:[{ validator: IntegerNumber, trigger: 'blur' }],
        cityOutAllowanceFee:[{ validator: IntegerNumber, trigger: 'blur' }],
        provinceOutAllowanceFee:[{ validator: IntegerNumber, trigger: 'blur' }],
        cityAllowanceCount:[{ validator: IntegerNumber, trigger: 'blur' }],
        cityOutAllowanceCount:[{ validator: IntegerNumber, trigger: 'blur' }],
        provinceOutAllowanceCount:[{ validator: IntegerNumber, trigger: 'blur' }],
        organizationCityAllowanceFee:[{ validator: IntegerNumber, trigger: 'blur' }],
        organizationCityOutAllowanceFee:[{ validator: IntegerNumber, trigger: 'blur' }],
        organizationProvinceOutAllowanceFee:[{ validator: IntegerNumber, trigger: 'blur' }],
        organizationCityAllowanceCount:[{ validator: IntegerNumber, trigger: 'blur' }],
        organizationCityOutAllowanceCount:[{ validator: IntegerNumber, trigger: 'blur' }],
        organizationProvinceOutAllowanceCount:[{ validator: IntegerNumber, trigger: 'blur' }],
      },
      isCreate:false,
      out:false,
    }
  },
  created() {
    this.isShowBtn("TrafficAllowance")//控制操作按钮的显示与隐藏
    this.getArea({value:{areaId:0},key:0})
  },
  methods:{
    handleSelectionChange(val) {
      this.selectRow = val
      console.log(val);
      
    },
    //分页
    get_page_number(pageNumer) {
      let [vm] = [this]
      vm.form.pageNumber = pageNumer;
      vm.Filter_file({api:vm.api,data:vm.form,callback:_d => vm.tableData = _d})
    },
    //提交请求
    submit() {
      let newForm = {}
      newForm = JSON.parse(JSON.stringify(this.editForm))
      delete newForm.areaId
      
      newForm.time = new Date(newForm.time).getTime()
      newForm.province = this.province
      newForm.city = this.city
      newForm.county = this.county
      newForm.town = this.town
      newForm.village = this.village
      this.$refs['editForm'].validate((valid)=>{
        if (valid && this.isCreate === true) {
          this.$api.create(this.api,newForm).then(res =>{
            if (res.data.status === 0) {
              this.$message.success('创建成功!')
              this.Filter_file({ api: this.api, data: this.form, callback: _d => this.tableData = _d })
            } else {
							this._status(res.data)
						}
          })
        } else if (valid && this.isCreate === false) {
          delete newForm.createTime
          this.$api.change(`${this.api}/modify`,newForm).then(res =>{
            if (res.data.status === 0) {
              this.$message.success('修改成功!')
              this.Filter_file({ api: this.api, data: this.form, callback: _d => this.tableData = _d })
            } else {
							this._status(res.data)
						}
          })
        } else {
          return false
        }
      })
    },
    //查询列表
    getData() {
      this.$api.getData(this.api,this.form).then(res =>{
        if (res.data.status === 0) {
          this.tableData = JSON.parse(res.data.data)
          this.total = res.data.size
        } else {
          this._status(res.data)
        }
      })
    }
  },
  watch:{
    centerDialogVisible:function(val){
      if (val === false)
        this.$refs.editForm.clearValidate()
    }
  }
}
</script>
<style>
/* .index .index-header .el-form-item__content{width: 200px;} */
.input-box>div{display: flex;flex-direction: column;flex-shrink: 0;}
</style>